import * as yup from 'yup'
import { EmailInputSchema, NameInputSchema, RoleInputSchema } from './common'

export const CardHolderSchema = NameInputSchema.concat(EmailInputSchema).concat(RoleInputSchema)

export type CardHolderInput = yup.Asserts<typeof CardHolderSchema>
